export default __webpack_public_path__ + "static/media/challenge.5dc45d25.png";